import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from '@lassi/util';

@Pipe({
  name: 'disallowedValues',
  standalone: true,
})
export class DisallowedValuesPipe implements PipeTransform {
  transform(value: unknown, disallowedValues: unknown[]): boolean {
    return !disallowedValues.includes(value);
  }
}

@Pipe({
  name: 'transformCrownStatus',
  standalone: true,
})
export class TransformCrownStatusPipe implements PipeTransform {
  transform(value: unknown): string {
    switch (value) {
      case 'C':
        return 'Crown Land';
      case 'G':
        return 'Government Road';
      case 'V':
        return 'Vested';
      default:
        return value as string;
    }
  }
}

@Pipe({
  name: 'transformParcelStatus',
  standalone: true,
})
export class TransformParcelStatusPipe implements PipeTransform {
  transform(value: unknown): string {
    return value === 'P' ? 'Proposed' : (value as string);
  }
}

@Pipe({
  name: 'transformZLevel',
  standalone: true,
})
export class TransformZLevelPipe implements PipeTransform {
  transform(value: unknown): { name: string; count?: string } {
    switch ((value as string).charAt(0)) {
      case 'G':
        return { name: 'Ground' };
      case 'S':
        return { name: 'Surface' };
      case 'B':
        return {
          name: `Below`,
          count: (value as string).slice(1),
        };
      case 'A':
        return {
          name: `Above`,
          count: (value as string).slice(1),
        };
      default:
        return { name: value as string };
    }
  }
}

@Pipe({
  name: 'formatAddress',
  standalone: true,
})
export class FormatAddressPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.split('\n').slice(0, 3).join(', ');
  }
}

@Pipe({
  name: 'yesNo',
  standalone: true,
})
export class YesNoPipe implements PipeTransform {
  transform(value: boolean | number | string | null | undefined): string {
    if (isNil(value)) return 'No';

    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'number') return value === 0 ? 'No' : 'Yes';

    return ['y', 'yes'].includes(value.trim().toLowerCase()) ? 'Yes' : 'No';
  }
}

@Pipe({
  name: 'stripQuotes',
  standalone: true,
})
export class StripQuotesPipe implements PipeTransform {
  transform(string: string | null | undefined): string {
    if (isNil(string)) return '';

    let str = string;
    if (
      (str.startsWith("'") && str.endsWith("'")) ||
      (str.startsWith('"') && str.endsWith('"'))
    ) {
      // Remove the first and last quotes
      str = str.slice(1, -1);
    }

    return str;
  }
}

@Pipe({
  name: 'newLine',
  standalone: true,
})
export class NewLinePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (isNil(value)) return '';
    return value
      .replace(/\\n/g, '\n')
      .replace(/\\r/g, '\r')
      .replace(/<br\s*?\/?>/g, '\n');
  }
}
